import React from "react";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import { connect } from "react-redux";
import "./themeToggleMobile.scss";
import { themeSetter } from "../../../../appRedux/ducks/themeMode";

const ThemeToggleMobile = ({ themeMode, themeToggle }) => {
  const lightTheme = themeMode === "light";
  const toggleTheme = () => {
    const newTheme = lightTheme ? "dark" : "light";
    themeToggle(newTheme);
  };

  // Regular expanded toggle with both buttons
  return (
    <button
      className={`theme-toggle-button-mobile theme-toggle-button-mobile-${themeMode}`}
      aria-label={`${themeMode} mode`}
      onClick={() => toggleTheme(lightTheme ? "dark" : "light")}
    >
      {lightTheme ? (
        <LightModeIcon fontSize="small" />
      ) : (
        <DarkModeIcon fontSize="small" />
      )}
      <span>Switch to {lightTheme ? "dark" : "light"} mode</span>
    </button>
  );
};

const mapStateToProps = (state) => ({
  themeMode: state.themeMode.themeMode,
});

const mapDispatchToProps = (dispatch) => ({
  themeToggle: (themeMode) => dispatch(themeSetter(themeMode)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThemeToggleMobile);

{
  /* <button
        onClick={() => toggleTheme("dark")}
        className={clsx(
          "theme-toggle-button",
          themeMode === "dark" ? "active" : "inactive",
        )}
        aria-label="Dark mode"
      >
        <DarkModeIcon fontSize="small" />
      </button> */
}
